import React from 'react';
import LudiButton from './LudiButton';

export default function LudiWorkoutHeroCard({
  workoutName,
  description,
  stats,
  onStart,
  loading,
}) {
  return (
    <div className="relative overflow-hidden rounded-ludi-xl border border-[var(--ludi-bdr-a)] bg-ludi-sf p-ludi-5">
      <div className="absolute inset-x-0 top-0 h-[3px] bg-ludi-emp" />
      <p className="text-ludi-micro font-bold uppercase tracking-widest text-ludi-t60 mb-ludi-2">Treino de hoje</p>
      <h2 className="text-ludi-2xl font-bold text-ludi-t100">{workoutName || '—'}</h2>
      {description && <p className="text-ludi-sm text-ludi-t60 mt-ludi-2 line-clamp-2">{description}</p>}
      {stats && (
        <div className="flex gap-ludi-6 mt-ludi-4">
          {stats.map((s) => (
            <div key={s.label}>
              <p className="text-ludi-xl font-bold text-ludi-t100 tabular-nums">{s.value}</p>
              <p className="text-ludi-micro uppercase tracking-widest text-ludi-t30">{s.label}</p>
            </div>
          ))}
        </div>
      )}
      <LudiButton className="mt-ludi-5" onClick={onStart} disabled={loading || !workoutName}>
        {loading ? 'A carregar…' : 'Iniciar treino'}
      </LudiButton>
    </div>
  );
}
